import { render, staticRenderFns } from "./Add-nova-vacinacao.vue?vue&type=template&id=470c5c26&scoped=true&"
import script from "./Add-nova-vacinacao.vue?vue&type=script&lang=js&"
export * from "./Add-nova-vacinacao.vue?vue&type=script&lang=js&"
import style0 from "./Add-nova-vacinacao.vue?vue&type=style&index=0&id=470c5c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c5c26",
  null
  
)

export default component.exports